<script setup>
const props = defineProps({
    value: [String, Object]
})
</script>

<template>
    <span>{{ value?.length?.toLocaleString() }}</span>
</template>